import PropTypes from 'prop-types'
import { Dialog, Stack, Button } from '@chakra-ui/react'

export const MultiButtonsPopupModal = ({ title, buttons, cancelCallback, width, isOpen = true }) => (
  <Dialog.Root placement="center" open={isOpen} onOpenChange={(details) => !details.open && cancelCallback?.()}>
    <Dialog.Backdrop />
    <Dialog.Positioner>
      <Dialog.Content maxW={width}>
        <Dialog.Body>{title}</Dialog.Body>
        <Dialog.Footer>
          <Stack direction="row" gap={0}>
            {buttons.map((button, index) => (
              <Button onClick={button.callback} key={`multi-buttons-popup-modal-${index}`} ml={4}>
                {button.title}
              </Button>
            ))}
          </Stack>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Positioner>
  </Dialog.Root>
)

MultiButtonsPopupModal.propTypes = {
  isOpen: PropTypes.bool,
  title: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired,
    }),
  ).isRequired,
  cancelCallback: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
